import Vue from 'vue';
import Vuex from 'vuex';
import { login } from '@/axios/userInfo';
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    gameToken: localStorage.getItem('gameToken') || '',
  },
  mutations: {
    SET_GAME_TOKEN(state, token) {
      state.gameToken = token;
      localStorage.setItem('lastLoginTime',+new Date)
      localStorage.setItem('gameToken',token)
    },
  },
  actions: {
    async login({ commit }, data) {
      try {
        const res = await login(data)
        const token = res.data.token
        commit('SET_GAME_TOKEN', token)
      } catch (err) {
        console.log('err:: ', err );
        alert('請輸入正確資訊')
      }
    },
  },
  getters: {
    nowGameToken(state) {
      return state.gameToken;
    },
  },
  modules: {
    // 定义模块化状态管理
  },
});
